<template>
  <transition name="notify" @afterLeave="afterLeave">
    <div v-if="visible" :class="wrapperClass">
      <img v-bind="iconProps" />
      <span class="notify-text">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: "BaseNotify",
  inheritAttrs: false
}
</script>

<script setup>
import error from "./images/error.png"
import success from "./images/success.png"
import warning from "./images/warning.png"

import { computed, onMounted, ref } from "vue"

const images = { success, error, warning }

const $props = defineProps({
  message: { type: [String, Number] },
  onClose: { type: Function },
  type: { type: String, default: "success" },
  timeout: { default: 1500, type: Number }
})

const wrapperClass = computed(() => {
  return ["base-notify-wrapper", $props.type]
})

const iconProps = computed(() => {
  return {
    class: "notify-icon",
    src: images[$props.type]
  }
})

/* 离开函数 */
const afterLeave = () => {
  $props.onClose?.()
}

const visible = ref(false)

onMounted(() => {
  visible.value = true

  setTimeout(() => {
    visible.value = false
  }, $props.timeout)
})
</script>

<style lang="less" scoped>
.base-notify-wrapper {
  --bg: #f1f8f5;
  --bd: #acd3c3;
  position: fixed;
  border-radius: 4px;
  left: 50%;
  top: 60px;
  transform: translateX(-50%);
  width: 600px;
  min-height: 70px;
  padding: 10px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--bd);
  color: rgba(0, 0, 0, 0.65);
  background: var(--bg);
  font-size: var(--fs-14);
  line-height: 1;
  letter-spacing: 2px;
  transition: all 0.4s;
  z-index: 9999;

  &.error {
    --bg: #fef1f1;
    --bd: #f7b0b0;
  }

  &.warning {
    --bg: #fff7ef;
    --bd: #facca0;
  }

  .notify-icon {
    width: 32px;
    margin-right: 14px;
  }
}

.notify-enter-from {
  opacity: 0;
  transform: translate(-50%, -100%) !important;
}

.notify-enter-to {
  opacity: 1;
  transform: translate(-50%, 0) !important;
}

.notify-leave-from {
  opacity: 1;
  transform: translate(-50%, 0) !important;
}

.notify-leave-to {
  opacity: 0;
  transform: translate(-50%, 100%) !important;
}
</style>
